import { render, staticRenderFns } from "./ValueSelection.vue?vue&type=template&id=3d8d0494&scoped=true&"
import script from "./ValueSelection.vue?vue&type=script&lang=js&"
export * from "./ValueSelection.vue?vue&type=script&lang=js&"
import style0 from "./ValueSelection.vue?vue&type=style&index=0&id=3d8d0494&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8d0494",
  null
  
)

export default component.exports